import React from 'react';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import { CardActionArea } from '@material-ui/core';
import { connect } from 'react-redux';
import { showHideScreenSize } from '../../actions/ShowHide';
import { dropShowHide } from '../../actions/dropShowHide';
import { darkTheme } from '../../actions/darkTheme';
import { useHistory } from 'react-router-dom';
import { redirect } from '../../helpers';
import ReactHtmlParser from 'react-html-parser';

const TriggerLine = ({ dark, direction, text }) => {
  let history = useHistory();
  return (
    <Container maxWidth="lg" className="my-3 mx-1 px-1 m-auto">
      <Grid container spacing={3} className="py-5">
        <Card className="w-100">
          <CardActionArea
            className="w-100 py-3 px-3"
            style={{
              backgroundColor: dark ? '#4A4A4A' : '#EEEEEE',
              color: dark ? '#EEEEEE' : '#4A4A4A',
            }}
          >
            <Typography
              variant="subtitle1"
              onClick={() => redirect(direction, history)}
            >
              {text.includes('<' || '>') ? ReactHtmlParser(text) : text}
            </Typography>
          </CardActionArea>
        </Card>
      </Grid>
    </Container>
  );
};

TriggerLine.defaultProps = {
  direction: '/FileManager',
  text: '<strong>+ Accede aquí</strong> a todo el material de estudio disponible',
};

const mapStateToProps = (state) => ({
  dark: state.dark,
});

export default connect(mapStateToProps, {
  showHideScreenSize,
  dropShowHide,
  darkTheme,
})(TriggerLine);
